import { cloneDeep } from '_utils';
import { PAYMENT } from './QuotationModel';

export const DEFAULT_FORWARD = [
  {
    ...PAYMENT, entree_value: 30, parcel: 6, payment_type: 'forward',
  },
  {
    ...PAYMENT, entree_value: 40, parcel: 8, payment_type: 'forward',
  },
  {
    ...PAYMENT, entree_value: 50, parcel: 10, payment_type: 'forward',
  },
];

const INSTALLMENT_FIELDS = ['id', 'entree_type', 'entree_value', 'parcel', 'payment_type'];

export const parseApiList = response => {
  if (Array.isArray(response)) {
    return response;
  }
  if (response && Array.isArray(response.data)) {
    return response.data;
  }
  return [];
};

export const normalizeTypeInstallment = installment => {
  const row = INSTALLMENT_FIELDS.reduce((acc, field) => {
    acc[field] = installment[field];
    return acc;
  }, {});

  if (row.entree_value != null && row.entree_value !== '') {
    row.entree_value = parseFloat(row.entree_value);
  }

  if (row.parcel != null && row.parcel !== '') {
    row.parcel = parseInt(row.parcel, 10);
  }

  return row;
};

export const buildForwardInstallments = installments => {
  const list = installments || [];
  const forwardInstallments = list
    .filter(item => !item.payment_type || item.payment_type === 'forward')
    .map(item => ({
      ...cloneDeep(PAYMENT),
      ...normalizeTypeInstallment(item),
      payment_type: 'forward',
    }));

  if (forwardInstallments.length) {
    return forwardInstallments;
  }

  return cloneDeep(DEFAULT_FORWARD);
};

export const findTypeById = (typeOptions, typeId) => {
  if (!typeId || !Array.isArray(typeOptions)) {
    return null;
  }

  return typeOptions.find(type => String(type.id) === String(typeId));
};

export const hasLoadedTypeOptions = typeOptions => (
  Array.isArray(typeOptions) && typeOptions.length > 0
);

export const isDefaultForward = forward => {
  if (!Array.isArray(forward) || forward.length !== DEFAULT_FORWARD.length) {
    return false;
  }

  return forward.every((item, index) => {
    const def = DEFAULT_FORWARD[index];
    return Number(item.entree_value) === Number(def.entree_value)
      && Number(item.parcel) === Number(def.parcel);
  });
};

export const shouldReapplyDefaultForward = (forward, quotationStepCompleted) => {
  if (!isDefaultForward(forward)) {
    return false;
  }

  const hasPersistedId = forward.some(item => item.id != null && item.id !== '');
  return !hasPersistedId || !quotationStepCompleted;
};

export const applyTypeForwardToGroup = (group, typeOptions, typeId) => {
  if (!group || !typeId || !hasLoadedTypeOptions(typeOptions)) {
    return group;
  }

  const selectedType = findTypeById(typeOptions, typeId);
  const forward = buildForwardInstallments(selectedType && selectedType.installments)
    .map(item => ({ ...item, id: null }));

  group.installments_by_types = {
    ...group.installments_by_types,
    forward,
  };

  return group;
};

export const applyTypeForwardToGroups = (groups, typeOptions, typeId) => {
  if (!Array.isArray(groups) || !typeId || !hasLoadedTypeOptions(typeOptions)) {
    return groups;
  }

  groups.forEach(group => applyTypeForwardToGroup(group, typeOptions, typeId));
  return groups;
};
